/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

const highlightBoxStyle = {
  box: {
    width: "100%",
    padding: "1rem",
    borderRadius: "25px",
  },
  headline: {
    color: "primary.main",
    fontWeight: 500,
    textAlign: "center",
    fontSize: "1.5rem",
    marginTop: 0,
  },
  left: {
    textAlign: "left",
  },
  center: {
    textAlign: "center",
  },
  right: {
    textAlign: "right",
  },
  defaultText: {
    color: "text.primary",
  },
  primaryText: {
    color: "primary.main",
  },
  defaultBorder: {
    border: "1px solid ",
    borderColor: "text.primary",
  },
  primaryBorder: {
    border: "1px solid ",
    borderColor: "primary.main",
  },
};

export default highlightBoxStyle;
